import { WalletConversionStatusResp } from 'types/api/response/wallet-conversion-status-resp'
import { WalletConversionErrorDto } from 'types/dtos/business-account'

import { api } from './api'

export const convertBusinessWallet = () =>
  api.post<WalletConversionStatusResp, WalletConversionErrorDto>('/business_accounts/conversion')
